// extracted by mini-css-extract-plugin
export default {"icon-default":"dGK8r","icon-default__size-m":"UtVhe","icon":"HgAR2"};